function ChatUser() {
	this.id = null;
	this.name = null;
	this.type = null;
	this.initial = null;
	this.online = false;

	this.init = function () {
		this.setInitial();
	};

	this.setInitial = function () {
		this.initial = this.name.charAt(0).toLowerCase();
	};
}